var exports = {
  "kL": "x04b3a21e--5eeb1e--container",
  "lZ": "x04b3a21e--5eeb1e--phone",
  "qr": "x04b3a21e--5eeb1e--footer",
  "QN": "x04b3a21e--5eeb1e--company",
};

module.exports = exports;
